module.exports = __webpack_public_path__ + "img/LUB00410.3a53cc3d.svg";